import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = typeof window !== "undefined" ? localStorage.getItem("kb_admin_token") : null;
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default api;

export const publicApi = {
  site: () => api.get("/site").then((r) => r.data),
  services: () => api.get("/services").then((r) => r.data),
  clients: () => api.get("/clients").then((r) => r.data),
  normas: () => api.get("/normas").then((r) => r.data),
  normaDetail: (slug) => api.get(`/normas/${slug}`).then((r) => r.data),
  casos: (params = {}) => api.get("/casos", { params }).then((r) => r.data),
  casoDetail: (slug) => api.get(`/casos/${slug}`).then((r) => r.data),
  testimonials: () => api.get("/testimonials").then((r) => r.data),
  faqs: () => api.get("/faqs").then((r) => r.data),
  resources: () => api.get("/resources").then((r) => r.data),
  sectors: () => api.get("/sectors").then((r) => r.data),
  contact: (payload) => api.post("/contact", payload).then((r) => r.data),
};

export const adminApi = {
  login: (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
  list: (coll) => api.get(`/admin/${coll}`).then((r) => r.data),
  create: (coll, payload) => api.post(`/admin/${coll}`, payload).then((r) => r.data),
  update: (coll, id, payload) => api.put(`/admin/${coll}/${id}`, payload).then((r) => r.data),
  remove: (coll, id) => api.delete(`/admin/${coll}/${id}`).then((r) => r.data),
  siteGet: () => api.get("/admin/site/content").then((r) => r.data),
  siteUpdate: (payload) => api.put("/admin/site/content", payload).then((r) => r.data),
};
